import * as runtypes from 'runtypes';

export const ParamsInstitution = runtypes.Record({
  localeIdentifier: runtypes.String
});

export type ParamsInstitution = runtypes.Static<typeof ParamsInstitution>;
